import React, {useEffect, useMemo, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {
    searchByTinChanged,
    searchByIrnChanged,
    searchByIdChanged,
} from 'models/profile/billingIvoice';

import {CancelIcon, StyledInput} from './styled';

export const TableSearch = ({searchField}: {searchField: 'tin' | 'irn' | 'id'}) => {
    const {t} = useTranslation();
    const [isFirstRender, setIsFirstRenter] = useState(true);
    const [value, setValue] = useState('');
    const delay = 1000;
    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value?.trim());
    };

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenter(false);
            return;
        }
        const timeoutId = setTimeout(() => {
            if (searchField === 'id') {
                searchByIdChanged(value);
            } else if (searchField === 'tin') {
                searchByTinChanged(value);
            } else {
                searchByIrnChanged(value);
            }
        }, delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    const placeholder = useMemo(() => {
        if (searchField === 'id') {
            return t('pages.profile.billing.searchById');
        }
        if (searchField === 'tin') {
            return t('pages.profile.billing.searchByTin');
        }
        return t('pages.profile.billing.searchByIrn');
    }, [searchField, t]);

    return (
        <StyledInput
            minWidth={searchField !== 'id' ? 240 : undefined}
            id={`billing-search-field-${searchField}`}
            value={value}
            onChange={handleValueChange}
            placeholder={placeholder}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
